import {isNil} from 'ramda';

const MAX_QUERY_LENGTH = 75;

/**
 * As in the `/` menu of the template editor (lexical-beautiful-mentions): the trigger counts only at
 * the start of the line or after whitespace or `(`, so `/` inside a word or a URL stays text. The
 * query may hold spaces but no further `/` and no line break.
 */
const TRIGGER_PATTERN = new RegExp(`(?:^|[\\s(])/(?<query>[^/\\n]{0,${MAX_QUERY_LENGTH}})$`);

/**
 * The open `/` trigger that ends at the caret: its offset in the given line text before the caret
 * and the query typed after it, or null.
 */
export function findTemplateTokenTrigger(textBeforeCaret: string) {
  const query = TRIGGER_PATTERN.exec(textBeforeCaret)?.groups?.query;

  if (isNil(query)) {
    return null;
  }

  return {offset: textBeforeCaret.length - query.length - 1, query};
}
